// components/SubscriptionCard.jsx
import { Card, Typography, Space, Tag } from "antd";
import { CalendarOutlined } from "@ant-design/icons";

const { Text, Title } = Typography;

export const SubscriptionCard = ({ startDate, endDate, daysLeft, t }) => {
  const expired = daysLeft < 0;
  const soon = daysLeft >= 0 && daysLeft <= 7;

  const badgeColor = expired ? "red" : soon ? "orange" : "gold";

  return (
    <Card
      title={t("mypage.subscription")}
      bordered={false}
      style={{
        borderRadius: 12,
        boxShadow: "0 8px 24px rgba(0,0,0,0.06)",
        height: "100%",
      }}
    >
      <Space direction="vertical" size={12} style={{ width: "100%" }}>
        {/* 残り日数 */}
        <div
          style={{
            background: "#FFFBE6",
            borderRadius: 8,
            padding: "16px 12px",
            textAlign: "center",
          }}
        >
          <Text type="secondary">{t("mypage.daysRemaining")}</Text>
          <Title level={2} style={{ margin: 0 }}>
            {daysLeft !== null ? `${Math.max(daysLeft, 0)} 日` : "-"}
          </Title>
          <Tag color={badgeColor} style={{ marginTop: 8 }}>
            {expired
              ? t("mypage.expired")
              : soon
              ? t("mypage.expiringSoon")
              : t("mypage.active")}
          </Tag>
        </div>

        {/* 期間 */}
        <Space>
          <CalendarOutlined />
          <Text>
            {startDate} – {endDate}
          </Text>
        </Space>
      </Space>
    </Card>
  );
};
